/**
 * Title for the first image-carousel slide of a transaction, which differs by transaction type.
 *
 * A "trip_charge" is the airport (GSP) billable event: a single LPR capture of the whole vehicle as
 * it enters, not a cropped plate image -- GSP emits no `frame_type = 'crop'` images at all -- so
 * calling that slide a "License Plate Capture" would mislabel what's on screen.
 *
 * Lives in its own module so it can be unit tested without pulling in TransactionHeader's Apollo
 * and lightbox dependencies.
 *
 * @param transactionType Value of `financial.transaction.transaction_type`, if known.
 */
export const firstCaptureSlideTitle = (transactionType?: string | null): string =>
  transactionType === "trip_charge" ? "Entry Capture" : "License Plate Capture";

export default firstCaptureSlideTitle;
